<template>
  <div class="container experience">
    <div style="fontSize:16px;color:black">
      订单管理
      <!-- <div class="content">
        <div class="left">
          <h2 class="title">学长订单</h2>
        </div>
        <div class="right"></div>
      </div> -->
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query"
               label-width="80px">
        <el-form-item label="订单号"
                      prop="order_no">
          <el-input v-model.trim="query.order_no"
                    placeholder="输入订单编号"
                    @input="searchSetTimeout()"
                    clearable
                    style="width:200px;"></el-input>
        </el-form-item>
        <el-form-item label="商品名称"
                      prop="goods_name">
          <el-input v-model.trim="query.goods_name"
                    placeholder="输入商品名称"
                    @input="searchSetTimeout()"
                    clearable
                    style="width:200px;"></el-input>
        </el-form-item>
        <el-form-item label="商品类型"
                      prop="status">
          <el-select v-model="query.note_ref_type"
                     placeholder="请选择"
                     clearable
                     @change="searchSetTimeout(true)"
                     style="width:150px;">
            <el-option v-for="item in filter.note_ref_type"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户昵称"
                      prop="name">
          <el-input v-model="query.user_keyword"
                    placeholder="输入用户ID/姓名/手机号"
                    @input="searchSetTimeout()"
                    clearable
                    style="width:300px;"></el-input>
        </el-form-item>

        <el-form-item label="订单状态"
                      prop="status">
          <el-select v-model="query.status"
                     placeholder="请选择"
                     clearable
                     @change="searchSetTimeout(true)"
                     style="width:200px;">
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          clearable
                          @change="timechange"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="完成时间">
          <el-date-picker class="datetime"
                          v-model="finishDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          clearable
                          @change="timefinishchange"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="headerTop">
        <p class="title">用户管理</p>
        <el-form size="small"
                 :inline="true">
          <el-form-item>
            <el-radio-group v-model="query.status"
                            @change="searchSetTimeout(true)">
              <el-radio-button label="">全部</el-radio-button>
              <el-badge :value="dropShipping"
                        class="item"
                        :hidden="dropShipping == 0"
                        :max="99">
                <el-radio-button label="2">待发货</el-radio-button>
              </el-badge>
              <el-badge :value="pendimdTutor"
                        class="item"
                        :hidden="pendimdTutor == 0"
                        :max="99">
                <el-radio-button label="6">待辅导</el-radio-button>
              </el-badge>

              <el-badge :value="inservice"
                        class="item"
                        :hidden="inservice == 0"
                        :max="99">
                <el-radio-button label="7">服务中</el-radio-button>
              </el-badge>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <div class="values">
        <el-table :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="order_id"
                           width="80"
                           label="订单ID"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.order_extend_info_obj.order_id}}
            </template>
          </el-table-column>
          <el-table-column prop="order_no"
                           width="200"
                           label="订单编号"
                           align="center">
          </el-table-column>
          <el-table-column label="用户昵称"
                           width="100"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-link type="primary"
                       @click="handleLookUser(scope.row.uid)"> {{scope.row.user?scope.row.user.nickname :''}}</el-link>
            </template>
          </el-table-column>

          <el-table-column prop="name"
                           label="商品名称"
                           align="center"
                           show-overflow-tooltip
                           width="240">
            <template slot-scope="scope">
              {{ scope.row.goods_name }}
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           label="订单规格"
                           align="center"
                           show-overflow-tooltip
                           width="130">
            <template slot-scope="scope">
              <div v-if="scope.row.sku">

                <span v-for="(item,index) in scope.row.sku.properties"
                      :key="index">
                  {{ item.val }}
                </span>
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="name"
                           label="商品类型"
                           align="center"
                           show-overflow-tooltip
                           width="90">
            <template slot-scope="scope">
              <div v-if="scope.row.order_note_info_obj">
                <span v-if="scope.row.order_note_info_obj.note_ref_type==1">资料</span>
                <span v-if="scope.row.order_note_info_obj.note_ref_type==2">课程</span>
                <span v-if="scope.row.order_note_info_obj.note_ref_type==3">答疑卡</span>
                <span v-if="scope.row.order_note_info_obj.note_ref_type==4">1对1</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="total_amount"
                           width="80"
                           label="订单金额"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.total_amount}}元
            </template>
          </el-table-column>
          <el-table-column prop="order_id"
                           width="80"
                           label="付款金额"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.pay_amount}}元
            </template>
          </el-table-column>

          <el-table-column label="订单状态"
                           align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status==0"
                      type="warning"> 待支付</el-tag>
              <el-tag v-if="scope.row.status==1"
                      type="success"> 已支付</el-tag>
              <el-tag v-if="scope.row.status==2"
                      type="warning"> 待发货</el-tag>
              <el-tag v-if="scope.row.status==3"> 待收货</el-tag>
              <el-tag v-if="scope.row.status==4"
                      type="success"> 已完成</el-tag>
              <el-tag v-if="scope.row.status==5"> 已取消</el-tag>
              <el-tag v-if="scope.row.status==6"
                      type="warning"> 待辅导</el-tag>
              <el-tag v-if="scope.row.status==7"> 辅导中</el-tag>
              <el-tag v-if="scope.row.status==8"> 待核销</el-tag>
              <el-tag v-if="scope.row.status==9"
                      type="info"> 核销中</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="支付方式"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.pay_type==0">-</span>
              <span v-else-if="scope.row.pay_type==1">支付宝</span>
              <span v-else-if="scope.row.pay_type==2">微信</span>
              <span v-else-if="scope.row.pay_type==3">系统</span>
              <span v-else-if="scope.row.pay_type==4">
                <span v-if="scope.row.hb_fq_seller_percent==100">
                  花呗分期(免{{scope.row.hb_fq_num}}期)
                </span>
                <span v-else>花呗分期</span>
              </span>
              <span v-else-if="scope.row.pay_type==5">研币</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_id"
                           width="80"
                           label="邀请人"
                           show-overflow-tooltip
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       @click="handleLookUser(scope.row.order_note_info_obj.note_invite_user_id)"
                       v-if="scope.row.order_note_info_obj">
                {{scope.row.order_note_info_obj.note_invite_user_nickname ?scope.row.order_note_info_obj.note_invite_user_nickname :'-'}}
              </el-link>

            </template>
          </el-table-column>
          <el-table-column prop="order_id"
                           width="80"
                           label="邀请收益"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.order_note_info_obj">
                {{scope.row.order_note_info_obj.note_invite_profit_amount  ?scope.row.order_note_info_obj.note_invite_profit_amount  :'-'}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="order_id"
                           width="80"
                           label="推荐人"
                           show-overflow-tooltip
                           align="center">
            <template slot-scope="scope">

              <el-link type="primary"
                       @click="handleLookUser(scope.row.order_note_info_obj.note_recommend_user_id)"
                       v-if="scope.row.order_note_info_obj">
                {{scope.row.order_note_info_obj.note_recommend_user_nickname   ?scope.row.order_note_info_obj.note_recommend_user_nickname   :'-'}}
              </el-link>

            </template>
          </el-table-column>
          <el-table-column prop="order_id"
                           width="80"
                           label="推荐收益"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.order_note_info_obj">
                {{scope.row.order_note_info_obj.note_recommend_profit_amount   ?scope.row.order_note_info_obj.note_recommend_profit_amount   :'-'}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="order_id"
                           width="80"
                           label="服务人"
                           show-overflow-tooltip
                           align="center">
            <template slot-scope="scope">

              <el-link type="primary"
                       @click="handleLookUser(scope.row.order_note_info_obj.note_service_user_id)"
                       v-if="scope.row.order_note_info_obj">
                {{scope.row.order_note_info_obj.note_service_user_nickname   ?scope.row.order_note_info_obj.note_service_user_nickname   :'-'}}

              </el-link>

            </template>
          </el-table-column>
          <el-table-column prop="order_id"
                           width="80"
                           label="服务收益"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.order_note_info_obj">
                {{scope.row.order_note_info_obj.note_service_profit_amount   ?scope.row.order_note_info_obj.note_service_profit_amount   :'-'}}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="下单时间"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.create_time">{{
                $moment(scope.row.create_time).format("YYYY-MM-DD hh:mm:ss")
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="支付时间"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.pay_time">{{
                $moment(scope.row.pay_time).format("YYYY-MM-DD hh:mm:ss")
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="完成时间"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.note_finish_time ).format("YYYY-MM-DD hh:mm:ss")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="160px"
                           align="center"
                           fixed="right">
            <template slot-scope="scope">
              <div style="display:flex;justify-content: center;">
                <div v-if="scope.row.status==2">
                  <el-link type="primary"
                           :underline="false"
                           @click="openDetail(scope.row,2)">立即发货</el-link>
                </div>
                <div v-else-if="scope.row.status==6"> <el-link type="warning"
                           :underline="false"
                           @click="openDetail(scope.row,2)">对接辅导</el-link></div>
                <div v-else-if="scope.row.status==7"> <el-link type="success"
                           :underline="false"
                           @click="openDetail(scope.row,2)">确认完成</el-link></div>
                <div v-else-if="scope.row.status==9"> <el-link type="success"
                           :underline="false"
                           @click="openDetail(scope.row,2)">确认完成</el-link></div>
                <div v-else> <el-link type="primary"
                           :underline="false"
                           @click="openDetail(scope.row,2)">查看详情</el-link></div>
                <div style="width:70px"> <el-link type="danger"
                           :underline="false"
                           @click="openDetail(scope.row,1)">退款</el-link></div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <OrderDialog :id="orderId"
                 :visible="dialogVisible"
                 :userStatus="userStatus"
                 :titles="title"
                 @close="handleClose()" />

    <UserDetail :visible="seniorVisible"
                :rowId="rowId"
                @close="seniorClose()"
                :editFlag="editFlag" />
  </div>
</template>

<script>
import OrderDialog from '@/components/dialog/senior/seniorOrderMange'
import { memberOrderlist } from '@/api/senior'
import UserDetail from '@/components/dialog/senior/userDetail'
// import UserSeniorMess from '@/components/dialog/senior/userSeniorMess'
// import UserMess from '@/components/dialog/senior/userMess'

let Timer = null // 定时器
let TimerTime = 500 // 定时器 等待时长

export default {
  components: {
    OrderDialog,
    UserDetail,
  },
  data() {
    return {
      dialogVisible: false,
      rowId: null,
      orderInfo: {},
      query: {
        order_status: '',
        referrer_version: '2',
        is_get_note_info: '1',
        user: '',
        senior: '',
        startTime: '',
        endTime: '',
        ref_type: '',
        type: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        status: '',
      },
      createDatetime: '',
      finishDatetime: '',
      pageTotal: 10,
      editFlag: false,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '待支付', value: '0' },
          { label: '已支付', value: '1' },
          { label: '待发货', value: '2' },
          { label: '待收货', value: '3' },
          { label: '已完成', value: '4' },
          { label: '已取消', value: '5' },
          { label: '待辅导', value: '6' },
          { label: '辅导中', value: '7' },
          { label: '待核销', value: '8' },
          { label: '核销中', value: '9' },
        ],
        types: [
          { label: '全部', value: '' },
          { label: '课程', value: 1 },
          { label: '题库', value: 2 },
          { label: '阅读资料', value: 3 },
          { label: '实体资料', value: 4 },
        ],
        note_ref_type: [
          { label: '资料', value: '1' },
          { label: '课程', value: '2' },
          { label: '答疑卡', value: '3' },
          { label: '1对1', value: '4' },
        ],
        checkStatus: [
          { label: '全部', value: '' },
          { label: '待发货', value: '2' },
          { label: '待辅导', value: '5' },
          { label: '服务中', value: '6' },
        ],
      },
      results: [],
      counts: {},
      isfixed: document.body.clientWidth < 820 ? false : true,
      orderId: null,
      orderRow: {},
      dropShipping: 0,
      pendimdTutor: 0,
      inservice: 0,
      title: '',
      rowDetail: {},
      userStatus: null,
      seniorVisible: false,
    }
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf()
        this.query.endTime = this.$moment(value[1]).valueOf()
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
  },
  created() {
    this.parseQuery()
    this.fetchOrderList()
    this.pendimdTutors()
    this.getdropShipping()
    this.getinservice()
  },
  methods: {
    handleLookUser(id) {
      this.rowId = id
      this.seniorVisible = true
    },
    seniorClose() {
      this.seniorVisible = false
    },
    handleClose() {
      this.dialogVisible = false
      this.title = ''
      this.fetchOrderList()
    },
    // 统计待发货
    getdropShipping() {
      memberOrderlist({
        status: 2,
        isPaging: 0,
        referrer_version: '2',
        is_get_note_info: '1',
      }).then((res) => {
        this.dropShipping = res.count
      })
    },
    //统计待辅导
    pendimdTutors() {
      memberOrderlist({
        status: 6,
        isPaging: 0,
        referrer_version: '2',
        is_get_note_info: '1',
      }).then((res) => {
        this.pendimdTutor = res.count
        console.log('pendimdTutor', this.pendimdTutor)
      })
    },
    //统计服务中
    getinservice() {
      memberOrderlist({
        status: 7,
        isPaging: 0,
        referrer_version: '2',
        is_get_note_info: '1',
      }).then((res) => {
        this.inservice = res.count
      })
    },
    // 学长订单列表请求
    fetchOrderList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      memberOrderlist(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    handleRender(value, type) {
      let productTypes = {
        1: '课程',
        2: '题库',
        3: '阅读',
        4: '实体资料',
      }
      let orderStatus = {
        1: '已支付',
        2: '待发货',
        3: '已发货',
        4: '可提现',
        5: '已提现',
        6: '已退款',
      }
      if (type == 'productType') {
        return productTypes[value] || ''
      } else if (type == 'orderStatus') {
        return orderStatus[value] || ''
      }
      return ''
    },
    handleInfo() {
      this.dialogVisible = true
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchOrderList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchOrderList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchOrderList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      // 手动处理
      this.createDatetime = null
      setTimeout(() => {
        this.fetchOrderList()
      }, 20)
    },
    statusRender(status) {
      const order_status = {
        0: '待支付',
        1: '已支付',
        2: '待发货',
        3: '待收货',
        4: '已完成',
        5: '已取消',
      }
      return order_status[status] || ''
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ]
      }
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    searchSetTimeout() {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        this.fetchOrderList(true)
      }, TimerTime)
    },
    timechange(e) {
      if (e == null) {
        this.query.startTime = ''
        this.query.endTime = ''
      }
      this.fetchOrderList(true)
    },
    timefinishchange(e) {
      if (e == null) {
        this.query.start_note_finish_time = ''
        this.query.end_note_finish_time = ''
      }
      this.fetchOrderList(true)
    },
    openDetail(row, type) {
      console.log('row44', row)

      this.orderId = row.id
      this.orderRow = row
      this.userStatus = row.status
      this.dialogVisible = true
      if (type == 1) {
        this.title = '退款'
      } else {
        this.title = undefined
      }
    },
  },
}
</script>

<style scoped lang="less">
::v-deep .el-table__fixed-right {
  background: #fff;
  z-index: 99 !important; /* 数值需高于滚动内容的z-index */
}
::v-deep .el-badge__content {
  z-index: 9999;
}
.experience {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 32px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        font-size: 14px;
        padding: 12px 20px;
      }
    }
  }
  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;
    .headerTop {
      display: flex;
      justify-content: space-between;
    }

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .menu-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
